var map = {
	"./de/data.json": [
		78515,
		8515
	],
	"./en/data.json": [
		61786
	],
	"./es/data.json": [
		91083,
		1083
	],
	"./fr/data.json": [
		15623,
		5623
	],
	"./ja/data.json": [
		39100,
		9100
	],
	"./pl/data.json": [
		18945,
		8945
	],
	"./pt/data.json": [
		5646,
		5646
	],
	"./tr/data.json": [
		84301,
		4301
	],
	"./uk/data.json": [
		11792,
		1792
	],
	"./vi/data.json": [
		19708,
		9708
	],
	"./zh/data.json": [
		92369,
		2369
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 47602;
module.exports = webpackAsyncContext;